var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24608 9.35817C7.8815 9.35817 7.59322 9.6415 7.59322 9.99984C7.59322 10.3498 7.8815 10.6415 8.24608 10.6415H13.3333V14.6248C13.3333 16.6665 11.646 18.3332 9.56028 18.3332H5.43116C3.35388 18.3332 1.66663 16.6748 1.66663 14.6332V5.37484C1.66663 3.32484 3.36236 1.6665 5.43964 1.6665H9.57724C11.646 1.6665 13.3333 3.32484 13.3333 5.3665V9.35817H8.24608ZM16.3585 7.11667L18.7918 9.54167C18.9168 9.66667 18.9835 9.825 18.9835 10C18.9835 10.1667 18.9168 10.3333 18.7918 10.45L16.3585 12.875C16.2335 13 16.0668 13.0667 15.9085 13.0667C15.7418 13.0667 15.5751 13 15.4501 12.875C15.2001 12.625 15.2001 12.2167 15.4501 11.9667L16.7835 10.6417H13.3335V9.35834H16.7835L15.4501 8.03334C15.2001 7.78334 15.2001 7.375 15.4501 7.125C15.7001 6.86667 16.1085 6.86667 16.3585 7.11667Z",
    fill: "#00609B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogoutIcon);
export default __webpack_public_path__ + "static/media/Menu-LogoutIcon.9371e02feadee71fee9f386d543929b1.svg";
export { ForwardRef as ReactComponent };